// extracted by mini-css-extract-plugin
module.exports =  {"page":"yV_SyU5tUU75zSicGtUM","chip":"_TST0VXFRwJFBwYXcfKU","alert":"bQUg2Jl34Qq5dbbdeXlR","logo":"Yr9FQZkBavaOUV71ziPQ","footer":"Gct3lYZXim8OUOm0hrWy"};